import { CloseIcon, HamburgerIcon } from "@chakra-ui/icons";
import {
  Image,
  Box,
  Button,
  IconButton,
  Divider,
  Flex,
  Heading,
  HStack,
  List,
  ListItem,
  Menu,
  MenuButton,
  VStack,
  Text, Link, Grid, useOutsideClick, useDisclosure,
} from "@chakra-ui/react";
import { RTag } from "@components/Texts/Tag/Tag";
import { WidgetTitle } from "@components/Texts/WidgetTitle/WidgetTitle";
import { baseUrl, generateBlogCategoryUrl, generateBlogTagUrl } from "@core/paths";
import { generatePageUrl } from "@core/utils";
import React from "react";
import { Link as GatsbyLink } from 'gatsby';
import { WindowSize } from "../../enums/windowSize";
import logoImg from "@images/logo.svg";
import { Cards } from "./cards";
import { Profiles } from "./profiles";
import FooterPolicy from "@components/Footer/footer";

const menuStylesOption = {
  [WindowSize.Mobile]: ({ isOpen }) => ({
    borderRadius: "50%",
    color: "#222C63",
    icon: isOpen ? <CloseIcon w="18px" fontSize="10px" /> : <HamburgerIcon fontSize="18px" />,
    _active: {
      bg: '#D1E6FF',
      borderColor: '#bec3c9',
    }
  }),
  [WindowSize.Desktop]: ({ isOpen }) => ({
    borderRadius: "5px",
    color: "#222C63",
    pl: "20px",
    mb: "20px",
    minW: "120px",
    rightIcon: isOpen ? <CloseIcon w="18px" fontSize="10px" /> : <HamburgerIcon fontSize="18px" />
  }),
}

export const CategoriesMenu = ({ additionalCategories, mainCategories, tags, windowSize, isMobile }) => {
  const ref = React.useRef()
  const { isOpen: isOpenMenu, onOpen, onClose } = useDisclosure()

  useOutsideClick({
    ref: ref,
    handler: () => onClose(),
  })

  return (
    <HStack ref={ref} spacing="26px">
      <HStack d={{base: "none", md: "flex"}} pl="40px" spacing="26px">
        {additionalCategories.map(({ categoryConfig, slug }) => (
          <GatsbyLink key={slug} to={generateBlogCategoryUrl(slug)}>
            {categoryConfig.logo && (<Image src={categoryConfig?.logo?.sourceUrl} alt="" maxH="37px" />)}
          </GatsbyLink>
        ))}
      </HStack>
      <Menu closeOnSelect={false} isOpen={isOpenMenu} onClose={onClose} onOpen={onOpen} closeOnBlur={false}>
        {({ isOpen }) => (
          <>
            <MenuButton
              {...menuStylesOption[windowSize](isOpen)}
              backgroundColor="#EAF4FF !important"
              as={windowSize === WindowSize.Mobile ? IconButton : Button}
              colorScheme='blue'
              fontSize="12px"
            >
              <Text d={{base: "none", md: "block"}}>Kategorie</Text>
            </MenuButton>

            {isOpen && (
              <Box id="categories_menu"
                   position="absolute"
                   left="-26px"
                   top={{base: '0', md: '100%'}}
                   h={{base: '100vh', md: 'auto' }}
                   overflow={{base: 'scroll'}}
                   w={{base: '100vw', md: '100%'}}
                   mt="116px"
                   right="0"
                   backgroundColor={{base: 'white', md: '#F5FAFF'}}
                   zIndex="9"
                   ml="0"
              >
                <Flex d={{base: "flex", md: "none"}} p="15px 26px" justifyContent="space-between" alignItems="center">
                  <GatsbyLink  to={baseUrl}><Image maxW="60%" src={logoImg}  alt="" /></GatsbyLink>
                  <MenuButton
                    {...menuStylesOption[WindowSize.Mobile]({ isOpen: true })}
                    backgroundColor="#EAF4FF !important"
                    as={IconButton}
                    colorScheme='blue'
                    fontSize="12px"
                  />
                </Flex>

                <Flex p="25px 15px" w="100%" d={{base: 'flex', md: 'none'}} justifyContent="center">
                  <Cards justifyContent="center" w="100%" isHome={true}/>
                </Flex>

                <Profiles p="0 14px" justifyContent="flex-start" mb="14px" d={{base: 'flex', md: 'none'}} />

                <HStack d={{base: 'none', md: 'flex'}} gridGap="60px" flexWrap="wrap" py="57px" px="37px" ml="0" alignItems="flex-start">
                  {mainCategories.map(mainCategory => (
                    <VStack key={mainCategory.slug} alignItems="flex-start">
                      <Heading fontSize="14px" size="xs" mb="15px">
                        <GatsbyLink to={generateBlogCategoryUrl(mainCategory.slug)}>{mainCategory.name}</GatsbyLink>
                      </Heading>
                      <VStack spacing="12px" pb="10px" alignItems="flex-start">
                        {mainCategory?.children?.nodes.map(({ slug, parent, name }) => (
                          <GatsbyLink key={slug} to={generateBlogCategoryUrl(slug, mainCategory.slug)}>{name}</GatsbyLink>
                        ))}
                      </VStack>
                      <Divider borderColor="#C0CEDB" w="52px" />
                    </VStack>
                  ))}
                </HStack>
                <Box mb="25px" w="100%" d={{base: 'block', md: 'none'}} flexWrap="wrap"  alignItems="flex-start">
                  {mainCategories.map((mainCategory, index) => (
                    <Flex flexDirection="column" justifyContent="center" width="100%" background={index % 2 ? '#EBF3FB' : '#F5FAFF' } key={mainCategory.slug} alignItems="flex-start">
                      <Heading textTransform="capitalize" p="14px 0 0 21px" fontSize="14px" size="xs" mb="15px">
                        <GatsbyLink to={generateBlogCategoryUrl(mainCategory.slug)}>{mainCategory.name.toLowerCase()}</GatsbyLink>
                      </Heading>
                      <VStack w="100%" fontSize="12px" p="0 21px">
                        <Grid w="100%" gap="14px" templateColumns="50% 50%" mb="14px" >
                          {mainCategory?.children?.nodes.map(({ slug, parent, name }) => (
                            <GatsbyLink key={slug} to={generateBlogCategoryUrl(slug, mainCategory.slug)}>
                              <Text textTransform="capitalize">
                                {name.toLowerCase()}
                              </Text>
                            </GatsbyLink>
                          ))}
                        </Grid>


                      </VStack>
                    </Flex>
                  ))}
                </Box>

                <VStack alignItems="flex-start" spacing="26px" px={{base: 0, md: "37px"}} pb={{base: 0, md: "36px"}}>
                  <WidgetTitle mx="0">Popularne tagi</WidgetTitle>
                  <Flex p={{base: '0 14px', md: 0}} wrap="wrap">
                    {tags.sort((a, b) => a.count - b.count).map(tag => (
                      <RTag key={tag.name} as={GatsbyLink} to={generateBlogTagUrl(tag.slug)} backgroundColor="#E7F2FF">{tag.name}</RTag>
                    )).slice(0, 41)}
                  </Flex>
                </VStack>

                <Divider mt={{base: '14px', md: 0}} borderBottom="1px solid #DFDFDF" mb="30px" />

                <Flex mb={{base: '100px', md: 0}} d={{base: 'block', md: 'flex'}} justifyContent="space-between" alignItems="flex-start" spacing="26px" px="37px" pb="36px">
                  <FooterPolicy/>
                </Flex>
              </Box>
            )}
          </>
        )}
      </Menu>
    </HStack>
  )
}

